import { Avatar, Box, Divider, Grid, Modal, Typography } from '@mui/material'
import React from 'react'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import moment from 'moment'
import { useTheme } from '@mui/styles'
import CloseIcon from '@mui/icons-material/Close'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { getUserDetails } from '../../../utils/LocalStorage'
import appassets from '../../../utils/appassets'
import { useNavigate } from 'react-router-dom'
import ImageComponent from '../../../commonComponents/ImageComponent'
import { ENV } from '../../../ENV'
// import CompanyDetailsUI from '../../../commonComponents/CompanyDetailsUI'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  borderRadius: 2,
  boxShadow: 5,
  height: '80vh',
  overflow: 'auto',
  width: '60%'
}
const responsiveStyle = {
  position: 'absolute',
  transform: 'translate(-0%, -0%)',
  bgcolor: 'white',
  height: '100%',
  overflow: 'auto',
  width: '100%'
}

export default function TotalReferralsModal ({ data, matches }) {
  const theme = useTheme()
  var { open, item, onClose } = data
  const navigate = useNavigate()
  var user = getUserDetails()
  const handleGetStatusText = status => {
    switch (status) {
      case 'pendingAtCandidate':
        return 'Approval is pending at candidate.'
      case 'pendingAtManager':
        return `Approval is pending at ${ENV.product_name} manager.`
      case 'pendingAtEmployer':
        return 'Approval is pending at employer.'
      case 'hired':
        return 'Candidate is hired.'
      case 'rejected':
        return 'Candidate is rejected.'
      case 'closed':
        return 'Application is closed.'
      case 'managerReview':
        return 'Application is at manager review.'
      case 'interviewStage':
        return 'Application is in interview stage'
      case 'offerStage':
        return 'Application is in offer stage'
      default:
        return ''
    }
  }
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={matches ? responsiveStyle : style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: matches ? 16 : 4,
            top: matches ? 16 : 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Typography id='modal-modal-title'>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ margin: '24px' }}>
              <TextBold style={{ fontSize: '18px', fontWeight: 800 }}>
                My Referrals
              </TextBold>
            </Grid>
            <Grid item xs={12}>
              <Grid
                item
                xs={12}
                style={{
                  border: `1px solid ${theme.palette.border.main}`,
                  margin: '0px 24px',
                  display: 'flex',
                  padding: '32px 16px'
                }}
              >
                {/* <CompanyDetailsUI item={item} /> */}
                <Grid container>
                  <Grid item style={{ display: 'flex', flexGrow: 1 }}>
                    <Grid
                      item
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        border: `1px solid ${theme.palette.border.main}`,
                        width: '57px',
                        height: '56px',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        padding: '8px',
                        objectFit: 'contain',
                        alignItems: 'center'
                      }}
                    >
                      <ImageComponent
                        alt='company logo'
                        src={item.profilePicture}
                        style={{ width: '100%' }}
                      />
                    </Grid>

                    <Grid item style={{ paddingLeft: '16px' }}>
                      <Grid item xs={12}>
                        <TextBold
                          style={{
                            fontSize: '18px'
                          }}
                        >
                          {item.jobTitle}
                        </TextBold>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        style={{
                          marginTop: '8px'
                        }}
                      >
                        <TextSemiBold
                          style={{
                            cursor: 'pointer',
                            lineHeight: '24px',
                            color: theme.palette.primary.main
                          }}
                          onClick={() =>
                            navigate('/recruiter/newcompany', {
                              state: item
                            })
                          }
                        >
                          {item.companyname} - {item.city},{item.countryName}
                        </TextSemiBold>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid item>
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <img
                          src={`${appassets.location}`}
                          alt='location'
                          style={{ marginRight: '8px' }}
                        />
                        <TextRegular
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary,
                            paddingRight: '16px'
                          }}
                        >
                          {item.city}, {item.state}, {item.countryName}
                        </TextRegular>
                      </Grid>
                    </Grid>
                    <Grid item style={{ marginTop: '8px' }}>
                      <Grid container direction={'row'}>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <img
                            src={`${appassets.suitcase}`}
                            alt='suitcase'
                            style={{ marginRight: '8px' }}
                          />
                          <TextRegular
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '16px',
                              lineHeight: '24px',
                              color: theme.palette.text.secondary,
                              paddingRight: '16px',
                              width: '6rem'
                            }}
                          >
                            {item.jobTypeName}
                          </TextRegular>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <img
                            src={`${appassets.time}`}
                            alt='time'
                            style={{ marginRight: '8px' }}
                          />
                          <TextRegular
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '16px',
                              lineHeight: '24px',
                              color: theme.palette.text.secondary,
                              paddingRight: '16px'
                            }}
                          >
                            {moment(item?.createdAt).fromNow()}
                          </TextRegular>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
        <Typography id='modal-modal-description'>
          <Grid container spacing={1} style={{ padding: '40px 24px' }}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={matches ? 2 : 1}>
                  <Avatar
                    src={`${appassets.user}`}
                    style={{
                      width: '48px',
                      height: '48px',
                      border: `1px solid ${theme.palette.border.main}`,
                      padding: '8px'
                    }}
                  />
                </Grid>
                <Grid item xs={10}>
                  {user?.firstname.charAt(0).toUpperCase() +
                    user?.firstname.slice(1)}{' '}
                  {user?.lastname.charAt(0).toUpperCase() +
                    user?.lastname.slice(1)}{' '}
                  (You)
                </Grid>
                <Grid item xs={12} style={{ width: '96%' }}>
                  {item?.applications.map((item, index) => (
                    <Grid container spacing={2} key={index}>
                      <Grid item xs={0.5}>
                        <Divider
                          orientation='vertical'
                          style={{
                            background: theme.palette.text.disabled,
                            width: '1px',
                            marginLeft: '20px'
                          }}
                        />
                      </Grid>
                      <Grid item xs={2.5}>
                        <Divider
                          style={{
                            position: 'relative',
                            top: '50px',
                            right: matches ? '-5px' : '10px',
                            width: matches ? '4rem' : '9rem',
                            background: theme.palette.text.disabled,
                            height: '1.5px'
                          }}
                        />
                        <ArrowForwardIosIcon
                          style={{
                            position: 'relative',
                            top: '38px',
                            left: matches ? '4rem' : '8rem',
                            fontSize: '12px',
                            color: theme.palette.text.disabled
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={matches ? 2 : 1}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: '12px'
                        }}
                      >
                        <Avatar
                          src={`${appassets.user}`}
                          style={{
                            width: '48px',
                            height: '48px',
                            border: `1px solid ${theme.palette.border.main}`,
                            padding: '8px'
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} style={{ marginTop: '12px' }}>
                        <Grid container spacing={0}>
                          <Grid item xs={10}>
                            <TextSemiBold style={{ fontSize: '14px' }}>
                              {item?.candidateFirstName}{' '}
                              {item?.candidateLastName}
                            </TextSemiBold>
                          </Grid>
                          <Grid item xs={10} style={{ fontSize: '12px' }}>
                            <TextRegular style={{ fontSize: '12px' }}>
                              {moment(item.createdAt).fromNow()}
                            </TextRegular>
                          </Grid>
                          <Grid item xs={10}>
                            <TextRegular style={{ fontSize: '12px' }}>
                              {item?.status === 'underConsideration'
                                ? handleGetStatusText(item?.subStatus)
                                : handleGetStatusText(item?.status)}
                              <br />
                              {item?.closeReason}
                            </TextRegular>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  )
}
